import script from "./KeyValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyValue.vue?vue&type=script&setup=true&lang=ts"

import "./KeyValue.vue?vue&type=style&index=0&id=1ae301cd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae301cd"]])

export default __exports__